import Accordion from '@components/Accordion';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

interface Props {
    note?: string;
}

function StampNote({ note }:Props) {
    const { t } = useTranslation('stamp');
    return (
        <Accordion title={t('notice.title')} >
            <Text color={colors.gray6} as='div'
                dangerouslySetInnerHTML={{ __html: note || '' }}
            />
        </Accordion>
    );
}

const Ol = styled.ol`
    list-style-type: decimal;
    list-style-position: outside;
    padding-inline-start: 18px;
`;

export default StampNote;
